import Vue from 'vue';
import VueI18n from 'vue-i18n';
import GERMAN_TRANSLATIONS from '../translations/ge';

Vue.use(VueI18n);

const TRANSLATIONS = {
	ge: { ...GERMAN_TRANSLATIONS },
};

export default new VueI18n({
	locale: 'ge',
	messages: TRANSLATIONS,
});

Vue.moment().locale('de-at');
